module.exports = __webpack_public_path__ + "static/media/aws.7c02dca8.svg";